<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col-12 md:col-12">
              <div class="">
                <div class="flex align-items-center">
                  <div class="ml-2">
                    <div class="text-xl text-primary font-bold">
                      {{ $t("review_and_submit") }}
                    </div>
                    <Divider></Divider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-12 sm:col-12 comp-grid">
            <div>
              <template v-if="!loading && item">
                <div class="grid">
                  <div class="col-12" v-if="applicationCompleted == true">
                    <Message
                      class="my-0"
                      icon="pi pi-send mr-4"
                      severity="success"
                      :closable="true"
                      >{{
                        $t("application_has_been_submitted_successfully")
                      }}</Message
                    >
                  </div>
                  <div v-if="applicationCompleted == false" class="col-12">
                    <div class="mb-2">
                      <div class="grid">
                        <div class="col-fixed" style="width: 120x">
                          <image-viewer
                            :ratio="1 / 1"
                            image-size="medium"
                            :src="item.passport_picture"
                          ></image-viewer>
                        </div>
                        <div class="col">
                          <div class="text-2xl">
                            {{ $t("submit_application_for_review") }}
                          </div>
                          <div class="my-2 text-gray-500">
                            {{
                              $t(
                                "you_will_not_be_able_make_any_changes_after_submission"
                              )
                            }}
                          </div>
                          <Divider />
                          <div class="">
                            <Button
                              :label="$t('submit_application')"
                              class="p-button-primary px-5"
                              :loading="saving"
                              @click="confirmSubmission()"
                            />
                          </div>
                          <slot :saving="saving"></slot>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="">
                      <Accordion>
                        <AccordionTab :header="$t('bio_information')">
                          <div class="grid">
                            <div class="col-12 md:col-12">
                              <div class="grid">
                                <div class="col-12 md:col-3 mb-4">
                                  {{ $t("applicant") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid">
                                    <div class="col italic text-gray-400">
                                      {{ $t("title") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.title }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("first_name") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.firstname }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("last_name") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.lastname }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("other_names") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.othernames }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">
                                  {{ $t("day_of_birth") }}:
                                </div>
                                <div class="col">
                                  {{ item.dob_day }} {{ item.dob_month }}
                                  {{ item.dob_year }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">
                                  {{ $t("country_of_origin") }}:
                                </div>
                                <div class="col">
                                  {{ item.country }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">{{ $t("home_town") }}:</div>
                                <div class="col">
                                  {{ item.hometown }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">
                                  {{ $t("home_town_region") }}:
                                </div>
                                <div class="col">
                                  {{ item.hometown_region }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{ $t("religious_denomination") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  {{ item.religious_denomination }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{ $t("religious_denomination") }} ({{
                                    $t("other")
                                  }}):
                                </div>
                                <div class="col-12 md:col-9">
                                  {{ item.religious_denomination_other }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">
                                  {{ $t("email_address") }}:
                                </div>
                                <div class="col">
                                  {{ item.email_address }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">
                                  {{ $t("marital_status") }}:
                                </div>
                                <div class="col">
                                  {{ item.marital_status }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">{{ $t("gender") }}:</div>
                                <div class="col">
                                  {{ item.gender }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">
                                  {{ $t("primary_contact") }}:
                                </div>
                                <div class="col">
                                  {{ item.dial_code }}
                                  {{ item.primary_telephone }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{ $t("address_of_applicant") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("address_line_1") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.address_line1 }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("address_line_2") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.address_line2 }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("address_line_3") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.address_line3 }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("address_line_4") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.address_line4 }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">
                                  {{ $t("digital_address") }}:
                                </div>
                                <div class="col">
                                  {{ item.digital_address }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{ $t("permanent_home_address") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("address_line_1") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.ph_address_line1 }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("address_line_2") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.ph_address_line2 }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("address_line_3") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.ph_address_line3 }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("address_line_4") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.ph_address_line4 }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-3">
                                  {{ $t("street_address") }}:
                                </div>
                                <div class="col">
                                  {{ item.street_address }}
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{ $t("sponsors_details") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("name_of_sponsor") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.sponsor_name }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("full_address_of_sponsor") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.sponsor_address }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("sponsor_telephone") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.sponsor_telephone }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("sponsor_email") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.sponsor_email }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{
                                    $t(
                                      "guardian_parent_next_of_kin_information"
                                    )
                                  }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="col">
                                    <div class="grid align-items-center">
                                      <div class="col italic text-gray-400">
                                        {{ $t("guardians_name") }}:
                                      </div>
                                      <div class="col">
                                        {{ item.guardian_name }}
                                      </div>
                                    </div>
                                    <hr />
                                    <div class="grid align-items-center">
                                      <div class="col italic text-gray-400">
                                        {{ $t("guardians_telephone") }}:
                                      </div>
                                      <div class="col">
                                        {{ item.guardian_telephone }}
                                      </div>
                                    </div>
                                    <hr />
                                    <div class="grid align-items-center">
                                      <div class="col italic text-gray-400">
                                        {{ $t("guardians_occupation") }}:
                                      </div>
                                      <div class="col">
                                        {{ item.guardian_occupation }}
                                      </div>
                                    </div>
                                    <hr />
                                    <div class="grid align-items-center">
                                      <div class="col italic text-gray-400">
                                        {{ $t("guardians_occupation") }} ({{
                                          $t("other")
                                        }}):
                                      </div>
                                      <div class="col">
                                        {{ item.guardian_occupation_other }}
                                      </div>
                                    </div>
                                    <hr />
                                    <div class="grid align-items-center">
                                      <div class="col italic text-gray-400">
                                        {{ $t("guardians_email") }}:
                                      </div>
                                      <div class="col">
                                        {{ item.guardian_email }}
                                      </div>
                                    </div>
                                    <hr />
                                    <div class="grid align-items-center">
                                      <div class="col italic text-gray-400">
                                        {{ $t("guardians_address_line_1") }}:
                                      </div>
                                      <div class="col">
                                        {{ item.guardian_address1 }}
                                      </div>
                                    </div>
                                    <hr />
                                    <div class="grid align-items-center">
                                      <div class="col italic text-gray-400">
                                        {{ $t("guardians_address_line_2") }}:
                                      </div>
                                      <div class="col">
                                        {{ item.guardian_address2 }}
                                      </div>
                                    </div>
                                    <hr />
                                    <div class="grid align-items-center">
                                      <div class="col italic text-gray-400">
                                        {{ $t("guardians_address_line_3") }}:
                                      </div>
                                      <div class="col">
                                        {{ item.guardian_address3 }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{ $t("sports_information") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("do_you_do_any_sports") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.is_athlete }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("last_competition") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.last_competition }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{
                                        $t(
                                          "would_you_like_to_represent_institution"
                                        )
                                      }}:
                                    </div>
                                    <div class="col">
                                      {{ item.sports_rep_institution }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{
                                    $t("disability_special_needs_information")
                                  }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("do_you_have_any_disability") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.is_disable }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("disability") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.disability }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("disability") }} ({{
                                        $t("other")
                                      }}):
                                    </div>
                                    <div class="col">
                                      {{ item.disability_other }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{ $t("employment_information") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("are_you_employed") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.is_employed }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("nature_of_employment") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.employment_nature }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("nature_of_employment") }} ({{
                                        $t("other")
                                      }}):
                                    </div>
                                    <div class="col">
                                      {{ item.employment_nature_other }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("name_and_address_of_employer") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.employment_address }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid align-items-center">
                                <div class="col-12 md:col-3">
                                  {{ $t("identification") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("national_id_type") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.national_id_type }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("national_id_number") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.national_id_number }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div v-if="item.scanned_national_id_card" class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("scanned_national_id_card") }}:
                                    </div>
                                    <div class="col">
                                      <a
                                        style="text-decoration: none"
                                        class="btn font-bold animate__shakeX text-green-500"
                                        target="_blank"
                                        :href="
                                          $utils.setFileUrl(
                                            item.scanned_national_id_card
                                          )
                                        "
                                        >{{
                                          $t(
                                            "click_here_to_view_uploaded_document"
                                          )
                                        }}</a
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </AccordionTab>

                        <AccordionTab :header="$t('family_information')">
                          <div class="grid">
                            <div class="col-12 md:col-12">
                              <div class="grid">
                                <div class="col-12 md:col-3">
                                  {{ $t("fathers_information") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid">
                                    <div class="col italic text-gray-400">
                                      {{ $t("fathers_name") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.fathers_name }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("fathers_living_status") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.fathers_living_status }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("fathers_telephone") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.fathers_telephone }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("fathers_occupation") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.fathers_occupation }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("fathers_occupation") }} ({{
                                        $t("other")
                                      }}):
                                    </div>
                                    <div class="col">
                                      {{ item.fathers_occupation_other }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("fathers_email") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.fathers_email }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid">
                                <div class="col-12 md:col-3">
                                  {{ $t("mothers_information") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid">
                                    <div class="col italic text-gray-400">
                                      {{ $t("mothers_name") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.mothers_name }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("mothers_living_status") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.mothers_living_status }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("mothers_telephone") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.mothers_telephone }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("mothers_occupation") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.mothers_occupation }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("mothers_occupation") }} ({{
                                        $t("other")
                                      }}):
                                    </div>
                                    <div class="col">
                                      {{ item.mothers_occupation_other }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("mothers_email") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.mothers_email }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </AccordionTab>

                        <AccordionTab :header="$t('academic_history')">
                          <div class="grid">
                            <div class="col-12 md:col-12">
                              <div class="grid">
                                <div class="col-12 md:col-3">
                                  {{ $t("shs_information") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid">
                                    <div class="col italic text-gray-400">
                                      {{
                                        $t("did_you_attend_senior_high_school")
                                      }}:
                                    </div>
                                    <div class="col">
                                      {{ item.attended_shs }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("country_or_location") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.shs_country }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("last_shs_attended") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.last_shs_attended }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("last_shs_attended") }} ({{
                                        $t("other")
                                      }}):
                                    </div>
                                    <div class="col">
                                      {{ item.last_shs_other }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("shs_outside_ghana") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.shs_outside_ghana }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("from") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.shs_from_year }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("to") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.shs_to_year }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("shs_course") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.shs_course }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("index_number") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.index_number }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("existing_qualification") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.existing_qualification }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("awaiting_results") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.is_awaiting_results }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid">
                                <div class="col-12 md:col-3">
                                  {{ $t("tertiary_institution_information") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid">
                                    <div class="col italic text-gray-400">
                                      {{
                                        $t(
                                          "have_you_attended_any_tertiary_institution"
                                        )
                                      }}:
                                    </div>
                                    <div class="col">
                                      {{ item.has_attended_tertiary }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("country_or_location") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.tertiary_country }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("last_tertiary_attended") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.last_tertiary_attended }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("tertiary_name_outside") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.tertiary_name_outside }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("from") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.tertiary_from_year }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("to") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.tertiary_to_year }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("tertiary_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.tertiary_programme }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("student_id_number") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.tertiary_student_id }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("tertiary_reason_for_leaving") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.tertiary_reason_for_leaving }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("degree_awarded") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.tertiary_degree_awarded }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("degree_class") }}:
                                    </div>
                                    <div class="col">
                                      {{ item.tertiary_degree_class }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>
                            <div
                              class="col-12 md:col-12"
                              v-if="item.exams_sittings"
                            >
                              <div
                                v-for="(definition, index) in JSON.parse(
                                  item.exams_sittings
                                )"
                                :key="index"
                              >
                                <div class="col-12 md:col-12">
                                  <div class="grid">
                                    <div class="col-12 md:col-3 text-purple-500 mb-2">
                                      {{
                                        $t("exams_sitting") + " " + (index + 1)
                                      }}:
                                    </div>
                                    <div class="col-12 md:col-9">
                                      <div class="grid">
                                        <div class="col italic text-gray-400">
                                          {{ $t("year") }}:
                                        </div>
                                        <div class="col">
                                          {{ definition.sitting_year }}
                                        </div>
                                      </div>
                                      <hr />
                                      <div class="grid align-items-center">
                                        <div class="col italic text-gray-400">
                                          {{ $t("month") }}:
                                        </div>
                                        <div class="col">
                                          {{ definition.sitting_month }}
                                        </div>
                                      </div>
                                      <hr />
                                      <div class="grid align-items-center">
                                        <div class="col italic text-gray-400">
                                          {{ $t("exams_type") }}:
                                        </div>
                                        <div class="col">
                                          {{ definition.exams_type }}
                                        </div>
                                      </div>
                                      <hr />
                                      <div class="grid align-items-center">
                                        <div class="col italic text-gray-400">
                                          {{ $t("index_number") }}:
                                        </div>
                                        <div class="col">
                                          {{ definition.index_number }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </AccordionTab>

                        <AccordionTab :header="$t('programme_selections')">
                          <div class="grid">
                            <div class="col-12 md:col-12">
                              <div class="grid">
                                <div class="col-12 md:col-3">
                                  {{ $t("first_institution") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid">
                                    <div class="col italic text-gray-400">
                                      {{ $t("first_choice_institution") }}:
                                    </div>
                                    <div class="col text-primary">
                                      {{ item.first_institution }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("first_choice_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{
                                        item.first_institution_first_caps_programme_title
                                      }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("second_choice_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{
                                        item.first_institution_second_caps_programme_title
                                      }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("third_choice_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{
                                        item.first_institution_third_caps_programme_title
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid">
                                <div class="col-12 md:col-3">
                                  {{ $t("second_institution") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid">
                                    <div class="col italic text-gray-400">
                                      {{ $t("second_choice_institution") }}:
                                    </div>
                                    <div class="col text-primary">
                                      {{ item.second_institution }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("first_choice_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{
                                        item.second_institution_first_caps_programme_title
                                      }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("second_choice_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{
                                        item.second_institution_second_caps_programme_title
                                      }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("third_choice_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{
                                        item.second_institution_third_caps_programme_title
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div class="col-12 md:col-12">
                              <div class="grid">
                                <div class="col-12 md:col-3">
                                  {{ $t("third_institution") }}:
                                </div>
                                <div class="col-12 md:col-9">
                                  <div class="grid">
                                    <div class="col italic text-gray-400">
                                      {{ $t("third_choice_institution") }}:
                                    </div>
                                    <div class="col text-primary">
                                      {{ item.third_institution }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("first_choice_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{
                                        item.third_institution_first_caps_programme_title
                                      }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("second_choice_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{
                                        item.third_institution_second_caps_programme_title
                                      }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col italic text-gray-400">
                                      {{ $t("third_choice_programme") }}:
                                    </div>
                                    <div class="col">
                                      {{
                                        item.third_institution_third_caps_programme_title
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </AccordionTab>

                        <AccordionTab :header="$t('funding_or_scholarship')">
                          <div class="grid">
                            <div class="col-12 md:col-12">
                              <div class="grid">
                                <div class="md:col-10">
                                  {{
                                    $t(
                                      "in_case_you_dont_meet_the_regular_cut_off_point_would_you_like_to_be_considered_for_fee_paying"
                                    )
                                  }}
                                </div>
                                <div class="md:col-2">
                                  {{ item.is_fee_paying }}
                                </div>
                              </div>
                              <hr />
                              <div class="grid">
                                <div class="md:col-10">
                                  {{
                                    $t(
                                      "in_case_you_are_not_offered_admission_would_you_like_the_selected_institution_to_pass_details_of_your_application_to_affiliated_private_universities"
                                    )
                                  }}
                                </div>
                                <div class="md:col-2">
                                  {{ item.pass_to_affiliate }}
                                </div>
                              </div>
                              <div class="grid">
                                <div class="md:col-12">
                                  <list-applicantselectedgrants-page
                                    is-sub-page
                                    ref="applicantSelectedGrantsListPage"
                                    :limit="10"
                                    :show-header="false"
                                    :show-breadcrumbs="false"
                                    :show-footer="false"
                                    :paginate="false"
                                    :show-edit-buttons="false"
                                    v-if="ready"
                                  >
                                  </list-applicantselectedgrants-page>
                                </div>
                              </div>
                            </div>
                          </div>
                        </AccordionTab>

                        <AccordionTab :header="$t('payment')">
                          <div class="grid">
                            <div class="col-12 md:col-12">
                              <view-payments-page
                                is-sub-page
                                ref="viewPaymentsPage"
                                v-if="ready"
                              >
                              </view-payments-page>
                            </div>
                          </div>
                        </AccordionTab>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="p-3 text-center">
                  <ProgressSpinner style="width: 50px; height: 50px" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { mapActions, mapGetters, mapState } from "vuex";
import { PageMixin } from "../../mixins/page.js";
import { ViewPageMixin } from "../../mixins/viewpage.js";
import { i18n } from "../../services/i18n.js";
import listApplicantselectedgrantsPage from "../applicant_selected_grants/list.vue";
import viewPaymentsPage from "../payments/view.vue";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "paymentApplicantsPage",
  components: { listApplicantselectedgrantsPage, viewPaymentsPage },
  mixins: [PageMixin, ViewPageMixin],
  props: {
    pageName: {
      type: String,
      default: "applicants",
    },
    idName: {
      type: String,
      default: "applicant_id",
    },
    routeName: {
      type: String,
      default: "applicantssummarydata",
    },
    pagePath: {
      type: String,
      default: "applicants/summarydata",
    },
    apiPath: {
      type: String,
      default: "applicants/summarydata",
    },
    pageIndex: { type: Number, default: 5 },
    applicationCompleted: { type: Boolean, default: false },
  },
  data() {
    return {
      item: {
        default: {},
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return this.$t("review_and_submit");
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["applicants/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("applicants/setCurrentRecord", value);
      },
    },
  },
  meta() {
    return {
      title: this.pageTitle,
    };
  },
  methods: {
    ...mapActions("applicants", ["fetchRecord", "submitApplication"]),
    confirmSubmission() {
      this.$confirm.require({
        message: this.$t("are_you_sure_you_want_to_submit_this_application"),
        header: this.$t("confirmation"),
        icon: "pi pi-info-circle",
        accept: () => {
          this.startApplicationSubmission();
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
    async startApplicationSubmission() {
      this.saving = true;
      let url = this.apiUrl;
      let payload = null;
      let data = { url, payload };
      this.submitApplication(data).then(
        (response) => {
          this.saving = false;
          this.flashMsg(this.$t("application_has_been_submitted_successfully"));
          this.closeDialogs(); // close page dialog that if opened
          this.navigateTo(`results`);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
  },
  watch: {
    $route(to, from) {
      //only fetch data when navigated to this page
      if (to.name == this.routeName) {
        //this.load();
      }
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
